<template>
<b-modal @hide="limparModal" no-close-on-backdrop no-close-on-esc header-bg-variant="dark" header-text-variant="light" :id="'modal-realizar-chamado'" size="xl" hide-footer centered title="AGENDAMENTO">
	<span class="d-flex flex-column">
                <strong>Status:</strong>
                <div class="d-flex gap-sm align-items-center mb-3">
                    <font-awesome-icon :icon="['fas', 'circle']" :class="selecionaCorOnline()" />
                    <span v-if="io.status">Online</span>
                    <span v-else>Offline</span>
                </div>
    </span>
	<div class="d-flex flex-lg-row flex-column gap-sm">
		<b-card class="d-flex flex-column gap-sm tamanhoCardChamado" header-bg-variant="secondary" header-text-variant="light">
            <template #header >
                <div class="w-100 text-left">
                    <h4 v-if="agendamentoSelecionado">
                     {{ agendamentoSelecionado.funcionario }}
                    </h4>
                </div>
            </template>
			<b-table :items="items" :fields="fields">
				<template #cell(sala)="data">
					{{ data.item.exame.salaExame }}
				</template>
				<template #cell(entrada)="data">
					{{ data.item.horario }}
				</template>
				<template #cell(saida)="data">
					{{ data.item.horarioSaida }}
				</template>
				<template #cell(acao)="data">
					<div class="d-flex gap-sm">
						<font-awesome-icon :icon="['fas', 'bell']"  :class="io.status && !botaoAcaoOcupado && data.item.podeSerChamado ? 'botaoAcao': 'botaoAcao-disabled botaoAcao'"  @click="realizarChamado(data.item)"/>
						<font-awesome-icon :icon="['fas', 'check']" :class="io.status && !botaoAcaoOcupado && data.item.podeSerChamado ? 'botaoAcao': 'botaoAcao-disabled botaoAcao' " @click="confirmarChamado(data.item)"/>
						<font-awesome-icon :icon="['fas', 'ban']" :class="!botaoAcaoOcupado || data.item.podeSerChamado ? 'botaoAcao': 'botaoAcao-disabled botaoAcao' " @click="$bvModal.show('modal-cancelar-exame-' + data.item.idExameAgendado)" />
					</div>
					<modalCancelarExameAgendado @exameCancelado="handleExameCancelado($event)" :exameAgendado="data.item"/>
				</template>
			</b-table>
    </b-card>
	<div class="tamanhoCardExame d-flex flex-column gap-md">
		<b-card class="d-flex flex-column gap-sm " header-bg-variant="secondary" header-text-variant="light">
            <template #header >
                <div class="w-100 text-center">
                    <h4>
                     Exames
                    </h4>
                </div>
            </template>
			<ul>
				<li v-for="(e,index) in items" :key="index" style="color: gray;">{{ e.exame.salaExame + " - " + e.exame.exame }}</li>
			</ul>
    </b-card>
	<div class="d-flex justify-content-end mt-auto">
		<b-button variant="outline-danger" size="lg" @click="abrirModalCancelarAgendamento">Cancelar</b-button>
	</div>
	</div>

	</div>
	<modalCancelarAgendamento @agendamentoCancelado="handleAgendamentoCancelado" :agendamento="agendamentoSelecionado"/>
</b-modal>
</template>
<script>
import ExameAgendadoService from "../../service/ExameAgendadoService.js";
import SocketService from "../../service/SocketService.js";
import ModalCancelarAgendamento from "./ModalCancelarAgendamento.vue";
import ModalCancelarExameAgendado from "./ModalCancelarExameAgendado.vue";

export default{
	name: "ModalRealizarChamado",
	components: {
		modalCancelarAgendamento: ModalCancelarAgendamento,
		modalCancelarExameAgendado: ModalCancelarExameAgendado,
	},
	data() {
		return {
			io: new SocketService(),
			agendamentoSelecionado: null,
			items: [],
			fields: [
				{
					key: "sala",
					label: "Sala",
				},
				{
					key: "entrada",
					label: "Entrada",
				},
				{
					key: "saida",
					label: "Saída",
				},
				{
					key: "acao",
					label: "Opções",
				},
			],

			botaoAcaoOcupado: false,
			acaoFinalizada: false,
		};
	},
	created() {
	},
	methods: {
		handleExameCancelado(id) {
			this.$bvModal.hide("modal-cancelar-exame-" + id);
			this.$emit("exameCancelado");
			this.consultarExamesPorAgendamento();
		},
		realizarChamado(chamado) {
			if (!this.io.status) {
				this.mensagem("Estamos Offline no momento, por favor aguarde uns instantes e tente novamente.", "Aviso", "warning");
				return;
			}
			if (!chamado.podeSerChamado) {
				this.mensagem("Esse exame já foi chamado!", "Aviso", "warning");
				return;
			}
			this.io.realizarChamado(chamado);
		},
		confirmarChamado(item) {
			this.botaoAcaoOcupado = true;
			if (!item.podeSerChamado) {
				this.mensagem("Esse exame já foi chamado!", "Aviso", "warning");
				return;
			}
			if (!this.io.status) {
				this.mensagem("Estamos Offline no momento, por favor aguarde uns instantes e tente novamente.", "Aviso", "warning");
				return;
			}
			ExameAgendadoService.confirmarChamado(item.idExameAgendado)
				.then(() => {
					this.mensagem("Chamado Confirmado Com Sucesso!", "Sucesso", "success");
					this.consultarExamesPorAgendamento();
				})
				.then(() => {
					this.$emit("chamadoConfirmado");
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível raelizar a confirmação do chamado nesse momento", "Erro", "danger");
					}
				})
				.finally(() => {
					this.botaoAcaoOcupado = false;
				});
		},

		selecionaCorOnline() {
			if (this.io.status) {
				return "verde";
			} else {
				return "vermelho";
			}
		},
		fecharModal() {
			this.$bvModal.hide("modal-realizar-chamado");
		},
		abrirModalCancelarAgendamento() {
			this.$bvModal.show("modal-cancelar-agendamento-" + this.agendamentoSelecionado.id);
		},
		handleAgendamentoCancelado() {
			this.$emit("agendamentoCancelado");
			this.fecharModal();
		},
		async abrirModal(agendamento) {
			this.agendamentoSelecionado = agendamento;
			this.io.conectar(0);
			this.io.isOnline();
			await this.consultarExamesPorAgendamento();
			this.$bvModal.show("modal-realizar-chamado");
		},
		async consultarExamesPorAgendamento() {
			if (!this.agendamentoSelecionado) {
				return;
			}
			ExameAgendadoService.consultar(this.agendamentoSelecionado.id)
				.then((res) => {
					this.items = res.data;
				}).catch((err) => {
					console.log(err);
				});
		},
		limparModal() {
			this.io.desconectar(0);
			this.isOnline = false;
			this.items = [];
			this.agendamentoSelecionado = null;
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

<style>
.verde{
    color: green;
}
.vermelho{
    color: red;
}
.tamanhoCardChamado{
	width: 65%;
}
.tamanhoCardExame{
	width: 35%;
}
.botaoAcao{
	background: rgb(1, 1, 49);
	padding: 5px 5px;
	border-radius: 20px;
	color: white;
	cursor: pointer;
	transition: all ease-in 0.3s;
}

.botaoAcao:hover{
	background: hsl(240, 96%, 10%, 0.74) !important;
}

.botaoAcao-disabled{
	cursor: not-allowed !important;
	background: hsl(240, 96%, 10%, 0.74) !important;
}
@media screen and (max-width:1200px){
    .tamanhoCardExame,.tamanhoCardChamado{
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Agendamento/ModalRealizarChamado.vue